// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"BundleLimitWidget_tooltipWrapper","wrapper":"BundleLimitWidget_wrapper","big":"BundleLimitWidget_big","label":"BundleLimitWidget_label"};